import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from "../form/FormMultiSelect";
import LocationContainer from '../../containers/Location';

class LocationMultiSelect extends PureComponent {
	componentDidMount() {
		const { locations, searchLocations } = this.props;
		if (_.isEmpty(locations)) {
			searchLocations();
		}
	}

	render () {
		const { locations, value } = this.props;

		let options = locations.map((location) => {
			return {
				value: location.locationId,
				display: location.display,
			}
		});
		options = _.sortBy(options, 'display');

		return (
			<FormMultiSelect
				{...this.props}
				// so an empty thing doesn't flicker in
				value={_.isEmpty(locations) ? [] : value}
				options={options}
			/>
		);
	}
}

LocationMultiSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	helpText : PropTypes.string,
};

LocationMultiSelect.defaultProps =  {
	label : 'Locations',
	locations: [],
};

export default LocationContainer(LocationMultiSelect);
